import windowReducer, { moduleName as windowModule } from 'models/window'
import battleReducer, { moduleName as battleModule } from 'models/battle'

const combinerReducer = {
    [windowModule]: windowReducer,
    [battleModule]: battleReducer,
}

export default combinerReducer
